import { render } from "./DefaultContainer.vue?vue&type=template&id=3eca0303&ts=true"
import script from "./DefaultContainer.vue?vue&type=script&lang=ts"
export * from "./DefaultContainer.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src129899678/src/web-ext-ai-voucher-humelo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__